<div class="d-flex flex-column-reverse flex-md-row" [ngClass]="{ 'justify-content-md-between': !cancelHidden }">
  <!-- @if(!cancelHidden){
  <button  type="button" class="btn cancel-btn border-0 mt-3 mt-md-0 ps-0"
    [disabled]="cancelDisabled" (click)="onCancel()">
    {{ cancelCaption }}
  </button>
  } -->
  <!-- <div class=" flex-column-reverse flex-md-row"> -->
    @if(!backHidden){
    <button  type="button" class="btn btn-nav back-btn mt-3 mt-md-0" [ngClass]="{
        ' me-md-4': !cancelHidden
      }" [disabled]="backDisabled" (click)="onBack()" role="button" tabindex="0">
      <img src="" class="back-icon-image icon-btn" alt="zurück" />
      {{ backCaption }}
    </button>
  }
  @if(!backHidden && isRegistration()){
    <button type="button"
      class="btn btn-nav back-btn mt-3 mt-md-0 custom-back-btn btn-prima"
      [ngClass]="{ 'ms-md-auto me-md-0 me-lg-4': !cancelHidden }" [disabled]="backDisabled" (click)="onBack()" role="button" tabindex="0">
      <img src="" class="registration-image icon-btn" alt="zurück" />
      {{ backCaption }}
    </button>
    }
    @if(!nextHidden){
    <button type="submit" class="btn btn-primary btn-nav btn-prima" [ngClass]="{
        'ms-md-auto': !alignNotReq
      }" [disabled]="nextDisabled" (click)="onNext()" role="button" tabindex="0">
      {{ nextCaption }}
    </button>
  }
  <!-- </div> -->
</div>
